import {getServerEndPoint} from "../liveshows/webEndPoint";
import axios from "axios";
import config from "../config/config";

const CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

const NUMBER_OF_SECTIONS = 3

const  SECTION_LENGTH = 4

const generateBarCode = () => {
    let codeBuilder =  [ ]
    for (let i = 0; i < NUMBER_OF_SECTIONS; i++) {
        let code4Digit = [ ]
        for (let j = 0; j < SECTION_LENGTH; j++) {
            const len = CHARACTERS.length - 1
            let randomIndex = Math.floor(Math.random() * len);
            code4Digit.push(CHARACTERS.charAt(randomIndex));
        }
        if (i < NUMBER_OF_SECTIONS) {
            codeBuilder.push(code4Digit.join(""));
        }
    }
    return codeBuilder.join("-")
}

const getSavedBarcode   =  ()=> {
    return sessionStorage.getItem("barcode")
}

const checkUpdateBarcode = async () => {
   let barcodeSaved = getSavedBarcode()
    const server = getServerEndPoint()  + 'barcode/qrcode'
    if(!barcodeSaved) {
        barcodeSaved = generateBarCode()
    }
    const data = {
        barcode : barcodeSaved,
        server : config.licence
    }

    const dataResponse = await fetch(server, {
        method: 'POST', body : JSON.stringify(data), headers : {
            'content-type': 'application/json'
        }
    })
    if(dataResponse.status === 200) {
        const imageBlob = await dataResponse.blob();
        sessionStorage.setItem("barcode", data.barcode)
        return URL.createObjectURL(imageBlob)
    }
}
const getService = () => {
   return  config.host
}

const  getEvents = async () => {
    const eventShows = await  axios.get(global.serverEndpoint + "api/liveShows")
    return eventShows?.data?.channels
}

const getSaveChannels = () => {
    const data = window.sessionStorage.getItem("Channels")
    if(data){
        return JSON.parse(data);
    }
}

const saveLoginData = (data, key) =>{
    window.sessionStorage.setItem(key, JSON.stringify(data));
}
const getSavedLoginData = (key) =>{
    const data = window.sessionStorage.getItem(key)
    if(data){
        const parsed = JSON.parse(data);
        // Strip quotes if it's a string
        if(typeof parsed === 'string') {
            return parsed.replace(/"/g, '')
        }
        return parsed
    }

}
const getServiceLabel = () => {
    return config.code.toLocaleUpperCase()
}

export {
    getService,
    getServiceLabel,
    checkUpdateBarcode,
    getSavedBarcode,
    generateBarCode,
    getEvents,
    getSaveChannels,
    saveLoginData,
    getSavedLoginData
}